import { c as i } from "./reactive-element-BDpydG15-BOs0_4cf.js";
import { render as a, noChange as d } from "./index-BqflxSah.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class r extends i {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e;
    const t = super.createRenderRoot();
    return (e = this.renderOptions).renderBefore != null || (e.renderBefore = t.firstChild), t;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = a(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) == null || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) == null || e.setConnected(!1);
  }
  render() {
    return d;
  }
}
var s;
r._$litElement$ = !0, r.finalized = !0, (s = globalThis.litElementHydrateSupport) == null || s.call(globalThis, { LitElement: r });
const l = globalThis.litElementPolyfillSupport;
l == null || l({ LitElement: r });
const u = { _$AK: (n, e, t) => {
  n._$AK(e, t);
}, _$AL: (n) => n._$AL };
var o;
((o = globalThis.litElementVersions) != null ? o : globalThis.litElementVersions = []).push("4.0.5");
export {
  r as s,
  u
};
